import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Tooltip } from 'antd';

import { selectDictionary } from 'features/dictionaries/dictionariesSelectors';

import { Application } from 'types/applications';

import { Dictionaries } from 'constants/enums';

import styles from './SkillMatch.module.scss';
import SkillsetItem from './SkillsetItem/SkillsetItem';
import getSkillMatchData from './utils/getSkillMatchData';

interface SkillMatchProps {
  matchData?: Application['matchData'];
  skillsetsAll?: string[];
  skillsetsMatches?: string[];
}

const SkillMatch = ({
  matchData,
  skillsetsAll,
  skillsetsMatches
}: SkillMatchProps) => {
  const { t } = useTranslation();
  const skillsetsDictionary = useSelector(
    selectDictionary(Dictionaries.Skillset)
  );

  const skillsetsList = matchData?.skillsetsAll || skillsetsAll;
  const skillsetsMatchesList = matchData?.skillsetsMatches || skillsetsMatches;

  if (!skillsetsList || !skillsetsMatchesList) {
    return null;
  }

  const { colorVarName, matchString } = getSkillMatchData(
    skillsetsList?.length,
    skillsetsMatchesList?.length
  );

  return (
    <Tooltip
      title={
        <div className={styles.tooltipWrapper}>
          {skillsetsList.map((skillset) => (
            <SkillsetItem
              key={skillset}
              skillset={skillset}
              skillsetsMatches={skillsetsMatchesList}
              skillsetsDictionary={skillsetsDictionary}
              colorVarName={colorVarName}
            />
          ))}
        </div>
      }
    >
      <div
        className={styles.wrapper}
        style={{ backgroundColor: `var(${colorVarName})` }}
      >
        <span className={styles.text}>
          {t('common.label.skillMatch', { skill: matchString })}
        </span>
      </div>
    </Tooltip>
  );
};

export default SkillMatch;
